module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-11"
  }, [_c('b-modal', {
    attrs: {
      "active": _vm.reminders.modalOpen,
      "has-modal-card": "has-modal-card",
      "width": 640
    },
    on: {
      "update:active": function($event) {
        return _vm.$set(_vm.reminders, "modalOpen", $event)
      }
    }
  }, [_c('reminder-modal', _vm._b({
    on: {
      "submit": _vm.submitReminder
    }
  }, 'reminder-modal', _vm.reminders.modalProps, false))], 1), _c('article', {
    staticClass: "card table-card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._v("Lembretes")]), _c('a', {
    staticClass: "card-header-icon",
    on: {
      "click": _vm.openModal
    }
  }, [_c('b-tooltip', {
    attrs: {
      "label": "Cadastrar Lembrete",
      "type": "is-dark",
      "position": "is-left"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "add_circle_outline"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "card-content is-paddingless"
  }, [_c('b-table', {
    attrs: {
      "data": _vm.reminders.data,
      "striped": true,
      "narrowed": false,
      "mobile-cards": false,
      "loading": _vm.reminders.isLoading
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "Item"
          }
        }, [_vm._v(_vm._s(props.row.name))]), _c('b-table-column', {
          attrs: {
            "label": "Tipo"
          }
        }, [_vm._v(_vm._s(props.row.type))]), _c('b-table-column', {
          attrs: {
            "label": "Valor Médio"
          }
        }, [_vm._v(_vm._s(_vm._f("currency")(props.row.value)))]), _c('b-table-column', {
          attrs: {
            "label": "Dia"
          }
        }, [_vm._v(_vm._s(props.row.day))]), _c('b-table-column', {
          attrs: {
            "centered": "centered",
            "label": "Gerenciar"
          }
        }, [_c('b-tooltip', {
          attrs: {
            "label": "Editar Lembrete",
            "type": "is-dark"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.openModal(props.row)
            }
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": "edit",
            "type": "is-primary",
            "size": "is-small"
          }
        })], 1)]), _c('b-tooltip', {
          staticStyle: {
            "margin-left": "20px"
          },
          attrs: {
            "label": "Excluir Lembrete",
            "type": "is-dark"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.confirmReminderDelete(props.row)
            }
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": "delete",
            "type": "is-danger",
            "size": "is-small"
          }
        })], 1)])], 1)]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c('p', [_c('b-icon', {
    attrs: {
      "icon": "sentiment_very_dissatisfied",
      "size": "is-large"
    }
  })], 1), _c('p', [_vm._v("Nenhum dado.")])])])])], 2)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03e232a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/components/Reminders.vue
// module id = 391
// module chunks = 56